module.exports = __webpack_public_path__ + "img/2023_chrysler-300s-01.e4e4ba74.jpg";